import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Axios from "../../../axios";
import { newAlert } from "../../../Slices/alertSlice";
import emailVerificationIcon from "../../../assets/images/emailVerificationicon.svg";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  // State definitions
  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [linkSent, setLinkSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const otpExceed = searchParams.get("otpExceed");

  // Form validation function
  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = emailRegex.test(email);

    if (!email) {
      errors.email = "Please enter your email";
    } else if (!isValidEmail) {
      errors.email = "Please enter a valid email";
    }

    return errors;
  };

  // Form submission handler
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);

    if (Object.keys(errors).length) {
      return;
    }

    setIsLoading(true);
    try {
      const res = await Axios.post("/api/session/forgot-password", {
        email,
      });
      if (res.status === 200) {
        setLinkSent(true);
      }
    } catch (err) {
      const error = err;
      const errorMessage =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        error.message ||
        "An error occurred while processing your request";
      dispatch(newAlert({ type: "danger", message: errorMessage }));
    } finally {
      setIsLoading(false);
    }
  };

  // Conditional rendering for link sent state
  if (linkSent) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-card forgot-password-card-sent">
          <img
            className="forgot-password-icon"
            src={emailVerificationIcon}
            alt="Email sent confirmation"
          />
          <h3 className="forgot-password-title">
            Check Your Email
          </h3>
          <p className="forgot-password-text">
            Reset password link sent to <br />
            <span className="forgot-password-email">{email}</span>
          </p>

          <p className="forgot-password-text">
            If the given email is registered, you will receive a reset password
            mail shortly.
          </p>

          <p className="forgot-password-text-muted">
            If you do not see reset password mail within 2 minutes, please check
            your spam folder.
          </p>
        </div>
      </div>
    );
  }

  // Main form render method
  return (
    <div className="forgot-password-container">
      {/* OTP exceed warning */}
      {otpExceed && (
        <div className="forgot-password-otp-warning">
          <span>
            You exceeded your attempts.
            <br />
            Please use forgot password below.
          </span>
        </div>
      )}

      <div className="forgot-password-card">
        <form onSubmit={handleForgotPassword}>
          {/* Form header */}
          <h3 className="forgot-password-title">
            Forgot Password
          </h3>
          <p className="forgot-password-description">
            Enter your email address and we will send you
            <br />
            instructions to reset your password.
          </p>

          {/* Email input field */}
          <div className="forgot-password-input-wrapper">
            <input
              className={`forgot-password-input ${
                formErrors.email ? "forgot-password-input-error" : ""
              }`}
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {formErrors.email && (
              <p className="forgot-password-error">{formErrors.email}</p>
            )}
          </div>

          {/* Submit button */}
          <button
            type="submit"
            disabled={isLoading}
            className="forgot-password-button"
          >
            {isLoading ? (
              <span
                className="forgot-password-spinner"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              "Continue"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;

